import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { initializeAuthActions } from '../../../common/actions/auth.actions';
import { getType } from 'typesafe-actions';
import { session as sessionStart } from '../login/login.actions';
import { session } from '../login/login.api';
import { rootSelector } from '../../../common/selectors/selectors';
import { isPasswordExpired as authIsPasswordExpired } from '../../../common/dtos/auth';
import { CircularProgress, Box } from '@material-ui/core';

const AuthCallback: React.FC = () => {
  const history = useHistory();
  const { tenant } = useParams<{ tenant: string }>();
  const dispatch = useDispatch();
  const authState = rootSelector((state) => state.auth);
  const [initialized, setInitialized] = React.useState(false);

  // Cookie-based auth only. Auth is already initialized by App.tsx on mount.
  // We just need to ensure XSRF-TOKEN cookie is set for subsequent requests.
  React.useEffect(() => {
    // Start session (sets XSRF-TOKEN cookie)
    // Auth initialization is already handled by App.tsx
    session().then((startSession: boolean) => {
      dispatch({ type: getType(sessionStart), payload: startSession });
    }).catch(() => {
      // Silently fail - session endpoint may return 401 if not authenticated
    });
  }, [dispatch]);

  // Watch for auth state changes and redirect appropriately
  React.useEffect(() => {
    if (initialized) {
      return; // Already handled redirect
    }

    // Wait for auth state to be initialized
    if (authState.isAuthenticated === true && 
        Array.isArray(authState.roles) && 
        authState.roles.length > 0) {
      setInitialized(true);
      
      // Check if password is expired - redirect to update-password page
      if (authIsPasswordExpired()) {
        history.replace(`/${tenant}/update-password`);
        return;
      }
      
      // Auth successful - redirect to appropriate route
      const isReadOnly = authState.roles.some((r: string) => r.toLowerCase() === 'readonly');
      const redirectRoute = isReadOnly ? '/employers' : '/actions';
      history.replace(redirectRoute);
    } else {
      // Check if we've waited long enough (auth initialization should complete quickly)
      // If still not authenticated after a delay, redirect to login
      const timer = setTimeout(() => {
        if (!authState.isAuthenticated && !initialized) {
          setInitialized(true);
          history.replace(`/${tenant}/login?error=auth_callback_failed`);
        }
      }, 2000); // Wait 2 seconds for auth initialization
      
      return () => clearTimeout(timer);
    }
  }, [authState, history, tenant, initialized]);

  return (
    <></>
    // <Box
    //   display="flex"
    //   justifyContent="center"
    //   alignItems="center"
    //   minHeight="100vh"
    // >
    //   <CircularProgress />
    // </Box>
  );
};

export default AuthCallback;
